// import './grossTareWeight.css';
import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { authKey, idToken, PERMISSIBLE_DEVIATION_CONFIG, GET_CONSIGNMENT_NO_TOKEN_NO_BY_URN, GET_LLE_GROSS_TARE_MEASUREMENT } from '../../common/URLs';
import jwt from 'jwt-decode';
import { Helmet } from 'react-helmet-async';
// import { ConfirmPopover } from '../../preregcamps/confirmPopover/confirmPopover';
// import { ErrorPopover } from '../../common/ErrorPopover/errorPopover';
// import { confirmAlert } from 'react-confirm-alert';
// import { loaderService } from "../../common/custom-loader/loader-service";
import { Box, Button, Card, CardContent, Container, Fab, Stack, TextField, Typography } from '@mui/material'
import { KeyboardArrowLeftRounded, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Table } from 'react-bootstrap';
import TrashIcon from '../../images/TrashIcon.png';
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { DataGrid } from '@mui/x-data-grid';
import { lastFiveDigitsComparator } from "../../common/commonFunction";

function TrialScreen() {

  const navigate = useNavigate();

  const columns = [

    { field: 'urn', headerName: 'URN', width: 180, sortComparator: (a, b) => lastFiveDigitsComparator(a, b) },
    { field: 'referenceNumber', headerName: 'Reference Number', width: 150 },
    // { field: 'stakeholderName', headerName: 'Stakeholder Name', width: 180 },
    { field: 'paymentType', headerName: 'Type of Payment', width: 150 },
    { field: 'stakeholderCategory', headerName: 'Stakeholder Category', width: 200 },
    { field: 'totalAmount', headerName: 'Amount(INR)', width: 120 },
    { field: 'createdOn', headerName: 'Creation Date', width: 150 },
    { field: 'paymentDate', headerName: 'Payment Date (if Paid)', width: 180 },
    { field: 'status', headerName: 'Status', width: 150 },
    { field: 'paymentId', headerName: 'Status', width: 150, hide: true }
  ];

  return (
    <>
      <Card>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            Dashboard
          </Typography>
          <Box style={{ height: 500, width: '100%' }}>
            {/* <DataGrid
              // rows={rows}
              rows
              columns={columns}
              pageSize={10}
              components={{ Toolbar: QuickSearchToolbar }} /> */}
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
export default TrialScreen;
